// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@stanion/App/Components/Common/XngLoadingOverlayUtilities";
import {
    globalTippyPopupStyle,
    mobileTippyRightSidePopupStyle,
    mobileTippyStyle,
} from "@stanion/App/Components/TippyPopup/Style";
import { xBaseTheme } from "@stanion/XDL/types";
import { css } from "styled-components";

export default {
    css: css`
        // webkit fix is used to prevent increase font-size of wide block "Safari auto font increase"
        body {
            -webkit-text-size-adjust: none;
        }
        ${hideLoadingOverlay}
        ${xngLoadingOverlayUtilitiesStyles}
        ${mobileTippyRightSidePopupStyle}        
        ${mobileTippyStyle}
        ${globalTippyPopupStyle}
    `,
} as xBaseTheme["globalStyle"];
